export default __webpack_public_path__ + "static/media/limb_medium@2x.1b773006.webp";